import { LayerType } from "../../types";
import { ThirdPartyOnDemandReportSelectionSidebar } from "./ThirdPartyOnDemandReportSelectionSidebar";

export const ThirdPartyOnDemandReportLayerType: LayerType = {
  id: "third-party-on-demand-report",
  SelectionSidebar: ThirdPartyOnDemandReportSelectionSidebar,
};
